module.exports = __webpack_public_path__ + "img/refresh.92531c66.svg";